import instance from '@/services/repository';

const resource = '/mailtemplates';

export default {
    get(type?: MailTemplateType) {
        if (type) {
            return instance.get(`${resource}?type=${type}`);
        } else {
            return instance.get(`${resource}`);
        }
    },
    getSingle(id: string) {
        return instance.get(`${resource}/${id}`);
    },
    create(payload: any) {
        return instance.post(`${resource}`, payload);
    },
    update(payload: any) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return instance.delete(`${resource}/${payload.id}`);
    },
};
